import Security20 from '@carbon/icons-react/es/security/20';
import React from 'react';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import { Page } from 'components/molecules/page';
import { HeaderWithIconTitle } from 'components/molecules/page/page';
import { SetupSaml } from 'components/organisms/saml';
import { TwoFactorAuthentication } from 'components/organisms/two-factor-authentication';
import { useTranslation } from 'hooks/use-translation';

const PageContent = styled(Page.Content)`
  padding: var(--layout-03);
`;

export const SecurityPage = () => {
  const title = useTranslation('security');

  return (
    <Page>
      <Helmet>{title}</Helmet>
      <Page.Header
        $white
        title={<HeaderWithIconTitle icon={<Security20 />} title={title} />}
      />
      <PageContent>
        <SetupSaml />
        <TwoFactorAuthentication />
      </PageContent>
    </Page>
  );
};
